export const ptBRCountries = {
  Afghanistan: "Afeganistão",
  Albania: "Albânia",
  Algeria: "Argélia",
  "American Samoa": "Samoa Americana",
  Andorra: "Andorra",
  Angola: "Angola",
  Anguilla: "Anguila",
  "Antigua and Barbuda": "Antígua e Barbuda",
  Argentina: "Argentina",
  Armenia: "Armênia",
  Aruba: "Aruba",
  Australia: "Austrália",
  Austria: "Áustria",
  Azerbaijan: "Azerbaijão",
  Bahamas: "Bahamas",
  Bahrain: "Bahrein",
  Bangladesh: "Bangladesh",
  Barbados: "Barbados",
  Belarus: "Bielorrússia",
  Belgium: "Bélgica",
  Belize: "Belize",
  Benin: "Benin",
  Bermuda: "Bermudas",
  Bhutan: "Butão",
  Bolivia: "Bolívia",
  "Bosnia and Herzegovina": "Bósnia e Herzegovina",
  Botswana: "Botsuana",
  Brazil: "Brasil",
  "British Indian Ocean Territory": "Território Britânico do Oceano Índico",
  "British Virgin Islands": "Ilhas Virgens Britânicas",
  Brunei: "Brunei",
  Bulgaria: "Bulgária",
  "Burkina Faso": "Burkina Faso",
  Burundi: "Burundi",
  Cambodia: "Camboja",
  Cameroon: "Camarões",
  Canada: "Canadá",
  "Cape Verde": "Cabo Verde",
  "Cayman Islands": "Ilhas Cayman",
  "Central African Republic": "República Centro-Africana",
  Chad: "Chade",
  Chile: "Chile",
  China: "China",
  "Christmas Island": "Ilha Christmas",
  "Cocos Islands": "Ilhas Cocos",
  Colombia: "Colômbia",
  Comoros: "Comores",
  "Cook Islands": "Ilhas Cook",
  "Costa Rica": "Costa Rica",
  Croatia: "Croácia",
  Cuba: "Cuba",
  Curacao: "Curaçao",
  Cyprus: "Chipre",
  "Czech Republic": "República Tcheca",
  "Democratic Republic of the Congo": "República Democrática do Congo",
  Denmark: "Dinamarca",
  Djibouti: "Djibuti",
  Dominica: "Dominica",
  "Dominican Republic": "República Dominicana",
  "East Timor": "Timor Leste",
  Ecuador: "Equador",
  Egypt: "Egito",
  "El Salvador": "El Salvador",
  "Equatorial Guinea": "Guiné Equatorial",
  Eritrea: "Eritreia",
  Estonia: "Estônia",
  Ethiopia: "Etiópia",
  "Falkland Islands": "Ilhas Malvinas",
  "Faroe Islands": "Ilhas Faroé",
  Fiji: "Fiji",
  Finland: "Finlândia",
  France: "França",
  "French Polynesia": "Polinésia Francesa",
  Gabon: "Gabão",
  Gambia: "Gâmbia",
  Georgia: "Geórgia",
  Germany: "Alemanha",
  Ghana: "Gana",
  Gibraltar: "Gibraltar",
  Greece: "Grécia",
  Greenland: "Groenlândia",
  Grenada: "Granada",
  Guam: "Guam",
  Guatemala: "Guatemala",
  Guernsey: "Guernsey",
  Guinea: "Guiné",
  "Guinea-Bissau": "Guiné-Bissau",
  Guyana: "Guiana",
  Haiti: "Haiti",
  Honduras: "Honduras",
  "Hong Kong": "Hong Kong",
  Hungary: "Hungria",
  Iceland: "Islândia",
  India: "Índia",
  Indonesia: "Indonésia",
  Iran: "Irã",
  Iraq: "Iraque",
  Ireland: "Irlanda",
  "Isle of Man": "Ilha de Man",
  Israel: "Israel",
  Italy: "Itália",
  "Ivory Coast": "Costa do Marfim",
  Jamaica: "Jamaica",
  Japan: "Japão",
  Jersey: "Jersey",
  Jordan: "Jordânia",
  Kazakhstan: "Cazaquistão",
  Kenya: "Quênia",
  Kiribati: "Kiribati",
  Kosovo: "Kosovo",
  Kuwait: "Kuwait",
  Kyrgyzstan: "Quirguistão",
  Laos: "Laos",
  Latvia: "Letônia",
  Lebanon: "Líbano",
  Lesotho: "Lesoto",
  Liberia: "Libéria",
  Libya: "Líbia",
  Liechtenstein: "Liechtenstein",
  Lithuania: "Lituânia",
  Luxembourg: "Luxemburgo",
  Macau: "Macau",
  Macedonia: "Macedônia do Norte",
  Madagascar: "Madagascar",
  Malawi: "Malawi",
  Malaysia: "Malásia",
  Maldives: "Maldivas",
  Mali: "Mali",
  Malta: "Malta",
  "Marshall Islands": "Ilhas Marshall",
  Mauritania: "Mauritânia",
  Mauritius: "Maurício",
  Mayotte: "Mayotte",
  Mexico: "México",
  Micronesia: "Micronésia",
  Moldova: "Moldávia",
  Monaco: "Mônaco",
  Mongolia: "Mongólia",
  Montenegro: "Montenegro",
  Montserrat: "Montserrat",
  Morocco: "Marrocos",
  Mozambique: "Moçambique",
  Myanmar: "Mianmar",
  Namibia: "Namíbia",
  Nauru: "Nauru",
  Nepal: "Nepal",
  Netherlands: "Países Baixos",
  "Netherlands Antilles": "Antilhas Holandesas",
  "New Caledonia": "Nova Caledônia",
  "New Zealand": "Nova Zelândia",
  Nicaragua: "Nicarágua",
  Niger: "Níger",
  Nigeria: "Nigéria",
  Niue: "Niue",
  "North Korea": "Coreia do Norte",
  "Northern Mariana Islands": "Ilhas Marianas do Norte",
  Norway: "Noruega",
  Oman: "Omã",
  Pakistan: "Paquistão",
  Palau: "Palau",
  Palestine: "Palestina",
  Panama: "Panamá",
  "Papua New Guinea": "Papua-Nova Guiné",
  Paraguay: "Paraguai",
  Peru: "Peru",
  Philippines: "Filipinas",
  Pitcairn: "Ilhas Pitcairn",
  Poland: "Polônia",
  Portugal: "Portugal",
  "Puerto Rico": "Porto Rico",
  Qatar: "Catar",
  "Republic of the Congo": "República do Congo",
  Reunion: "Reunião",
  Romania: "Romênia",
  Russia: "Rússia",
  Rwanda: "Ruanda",
  "Saint Barthelemy": "São Bartolomeu",
  "Saint Helena": "Santa Helena",
  "Saint Kitts and Nevis": "São Cristóvão e Nevis",
  "Saint Lucia": "Santa Lúcia",
  "Saint Martin": "São Martinho",
  "Saint Pierre and Miquelon": "São Pedro e Miquelon",
  "Saint Vincent and the Grenadines": "São Vicente e Granadinas",
  Samoa: "Samoa",
  "San Marino": "San Marino",
  "Sao Tome and Principe": "São Tomé e Príncipe",
  "Saudi Arabia": "Arábia Saudita",
  Senegal: "Senegal",
  Serbia: "Sérvia",
  Seychelles: "Seychelles",
  "Sierra Leone": "Serra Leoa",
  Singapore: "Singapura",
  "Sint Maarten": "São Martinho",
  Slovakia: "Eslováquia",
  Slovenia: "Eslovênia",
  "Solomon Islands": "Ilhas Salomão",
  Somalia: "Somália",
  "South Africa": "África do Sul",
  "South Korea": "Coreia do Sul",
  "South Sudan": "Sudão do Sul",
  Spain: "Espanha",
  "Sri Lanka": "Sri Lanka",
  Sudan: "Sudão",
  Suriname: "Suriname",
  "Svalbard and Jan Mayen": "Svalbard e Jan Mayen",
  Swaziland: "Eswatini",
  Sweden: "Suécia",
  Switzerland: "Suíça",
  Syria: "Síria",
  Taiwan: "Taiwan",
  Tajikistan: "Tajiquistão",
  Tanzania: "Tanzânia",
  Thailand: "Tailândia",
  Togo: "Togo",
  Tokelau: "Tokelau",
  Tonga: "Tonga",
  "Trinidad and Tobago": "Trinidad e Tobago",
  Tunisia: "Tunísia",
  Turkey: "Turquia",
  Turkmenistan: "Turcomenistão",
  "Turks and Caicos Islands": "Ilhas Turcas e Caicos",
  Tuvalu: "Tuvalu",
  "U.S. Virgin Islands": "Ilhas Virgens Americanas",
  Uganda: "Uganda",
  Ukraine: "Ucrânia",
  "United Arab Emirates": "Emirados Árabes Unidos",
  "United Kingdom": "Reino Unido",
  "United States": "Estados Unidos",
  Uruguay: "Uruguai",
  Uzbekistan: "Uzbequistão",
  Vanuatu: "Vanuatu",
  Vatican: "Vaticano",
  Venezuela: "Venezuela",
  Vietnam: "Vietnã",
  "Wallis and Futuna": "Wallis e Futuna",
  "Western Sahara": "Saara Ocidental",
  Yemen: "Iêmen",
  Zambia: "Zâmbia",
  Zimbabwe: "Zimbábue",
};
